
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["c-icon c-icon-xl",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{staticClass:"ci-primary",attrs:{"fill":"var(--ci-primary-color, currentColor)","ry":"70.186","rx":"58.426","cy":"232.252","cx":"67.338"}}),_c('ellipse',{staticClass:"ci-primary",attrs:{"fill":"var(--ci-primary-color, currentColor)","ry":"70.186","rx":"53.956","cy":"221.217","cx":"446.749"}}),_c('ellipse',{staticClass:"ci-primary",attrs:{"fill":"var(--ci-primary-color, currentColor)","cx":"337.914","cy":"119.555","rx":"57.235","ry":"73.07"}}),_c('ellipse',{staticClass:"ci-primary",attrs:{"fill":"var(--ci-primary-color, currentColor)","cx":"198.008","cy":"87.522","rx":"64.686","ry":"73.07"}}),_c('path',{staticClass:"ci-primary",attrs:{"fill":"var(--ci-primary-color, currentColor)","d":"M443.846 393.034c0 81.773-99.497 105.759-183.624 105.759S89.118 474.807 89.118 393.034s86.977-190.367 171.104-190.367c84.127 0 183.624 108.594 183.624 190.367z"}})])
          )
        }
      }
    